import { ChatCompletionResponseMessageRoleEnum } from "../types/chat-completion.type";

export const getAiMessage = (messages: any[]) => {
  return (
    messages
      .reverse()
      .find(
        (message) =>
          message.role !== ChatCompletionResponseMessageRoleEnum.User
      )?.content ?? null
  );
};
